import { get, getRawValue } from '../../utils/get';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { hasMissingSchemaVariables } from '../../adapters/utils';
import { getImageWithThumbnailObject } from '../../adapters/get-image-with-thumbnail-object';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
import { IDs } from './ids-stores-product';
import { requiredSchemaVariables } from './required-schema-variables';
import HTMLParser from '../../utils/html-parser';
export var isV3Product = function (itemData) { var _a; return Boolean((_a = itemData === null || itemData === void 0 ? void 0 : itemData.product) === null || _a === void 0 ? void 0 : _a.revision); };
export var getV3ProductData = function (item) {
    var _a;
    var mediaItems = getRawValue(item, 'product.media.itemsInfo.items') || [];
    var imagesSD = mediaItems.map(function (mediaItem) {
        return getImageWithThumbnailObject(mediaItem.image, mediaItem.thumbnail);
    });
    var getDescription = function (productItem) {
        var plainDescription = get(productItem, 'product.plainDescription');
        var handler = {
            textContent: '',
            chars: function (text) {
                this.textContent += text + ' ';
            },
        };
        HTMLParser(plainDescription, handler);
        return handler.textContent.trim();
    };
    var salePrice = get(item, 'product.salePriceRange.minValue.amount');
    var basePrice = get(item, 'product.basePriceRange.minValue.amount');
    var price = salePrice !== '' ? salePrice : basePrice;
    var baseUrl = get(item, 'product.url.url').replace(get(item, 'product.url.relativePath'), '');
    return _a = {},
        _a[IDs.SITE_NAME] = get(item, "context.".concat(CONTEXT_PROPS.SITE_NAME)),
        _a[IDs.BUSINESS_NAME] = get(item, "context.".concat(CONTEXT_PROPS.BUSINESS_NAME)),
        _a[IDs.INDEX_SITE] = getRawValue(item, "context.".concat(CONTEXT_PROPS.INDEX_SITE)),
        _a[IDs.INDEX_PAGE] = getRawValue(item, "context.".concat(CONTEXT_PROPS.INDEX_PAGE)),
        _a[IDs.ID] = get(item, 'product.id'),
        _a[IDs.SKU] = get(item, 'product.minVariantPriceInfo.sku'),
        _a[IDs.TITLE] = get(item, 'product.name'),
        _a[IDs.DESCRIPTION] = getDescription(item),
        _a[IDs.BRAND] = get(item, 'product.brand.name'),
        _a[IDs.PRICE] = price,
        _a[IDs.CURRENCY] = get(item, 'product.currency'),
        _a[IDs.TYPE] = get(item, 'product.productType'),
        _a[IDs.WEIGHT] = get(item, 'product.physicalProperties.shippingWeightRange'),
        _a[IDs.AVAILABILITY_SCHEMA] = "".concat(get(item, 'product.inventory.availabilityStatus')) === 'IN_STOCK'
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock',
        _a[IDs.AVAILABILITY_META_TAG] = "".concat(get(item, 'product.inventory.availabilityStatus')) === 'IN_STOCK'
            ? 'InStock'
            : 'out of stock',
        _a[IDs.SLUG] = get(item, 'product.slug'),
        _a[IDs.MAIN_IMAGE] = get(item, 'product.media.main.image.url'),
        _a[IDs.IMAGE_WIDTH] = get(item, 'product.media.main.image.width'),
        _a[IDs.IMAGE_HEIGHT] = get(item, 'product.media.main.image.height'),
        _a[IDs.IMAGE_ALT] = get(item, 'product.media.main.image.altText'),
        _a[IDs.THUMBNAIL_URL] = get(item, 'product.media.main.image.url'),
        _a[IDs.THUMBNAIL_WIDTH] = get(item, 'product.media.main.image.width'),
        _a[IDs.THUMBNAIL_HEIGHT] = get(item, 'product.media.main.image.height'),
        _a[IDs.THUMBNAIL_ALT] = get(item, 'product.media.main.image.altText'),
        _a[IDs.SD_JSON_IMAGES] = imagesSD,
        _a[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.STORES_PRODUCT, item, get(item, 'product.url.url')),
        _a[IDs.PRODUCT_PAGE_BASE_URL] = baseUrl,
        _a[IDs.DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, item),
        _a[IDs.MEDIA_ITEMS] = mediaItems,
        _a[IDs.FULL_DESCRIPTION] = get(item, 'product.plainDescription'),
        _a;
};
